import { render, staticRenderFns } from "./LotdStatsComponent.vue?vue&type=template&id=6fc9804f&scoped=true"
import script from "./LotdStatsComponent.vue?vue&type=script&lang=ts"
export * from "./LotdStatsComponent.vue?vue&type=script&lang=ts"
import style0 from "./LotdStatsComponent.vue?vue&type=style&index=0&id=6fc9804f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9804f",
  null
  
)

export default component.exports